module.exports = __webpack_public_path__ + "static/media/kids.9a28f732.jpg";